import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import placeholder from "assets/imgs/placeholder-img.jpg";
import icon from "assets/imgs/icon.png";

import { isImage, newId, getExtension } from "utils/Utils.js";
import Firebase from "Firebase.js";

export default function CriarAnunciante() {
  const [image, setImage] = useState(null);
  const [nome, setNome] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [emailResponsavel, setEmailResponsavel] = useState("");
  const [telefoneResponsavel, setTelefoneResponsavel] = useState("");

  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nome && image && responsavel) {
      if (isImage(image.name)) {
        setLoading(true);
        const id = newId();
        const filename = id + "." + getExtension(image.name);
        let resStorage = await Firebase.fire
          .storage()
          .ref("anunciantes/" + filename)
          .put(image);
        const imageUrl = await resStorage.ref.getDownloadURL();
        await Firebase.fire.firestore().collection("anunciantes").doc(id).set({
          id: id,
          nome: nome,
          responsavel: responsavel,
          emailResponsavel: emailResponsavel,
          telefoneResponsavel: telefoneResponsavel,
          imageFile: filename,
          imageUrl: imageUrl,

          createdAt: Date.now(),
        });
        setLoading(false);
        alert("Anunciante criado com sucesso!");
        setNome("");
        setImage(null);
        setResponsavel("");
        setEmailResponsavel("");
        setTelefoneResponsavel("");
      } else {
        alert("O arquivo deve ser uma imagem.");
      }
    } else {
      alert("Preencha todos os campos.");
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleNomeChange = (e) => {
    setNome(e.target.value);
  };

  const handleResponsavelChange = (e) => {
    setResponsavel(e.target.value);
  };
  const handleEmailResponsavelChange = (e) => {
    setEmailResponsavel(e.target.value);
  };
  const handleTelefoneResponsavelChange = (e) => {
    setTelefoneResponsavel(e.target.value);
  };

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Criar Anunciante</Typography>
          <Divider />
        </Grid>

        <Grid item xs={10} style={{ textAlign: "center" }}>
          <form onSubmit={submit}>
            <Paper elevation={3} style={{ paddingTop: "15px" }}>
              <img
                src={image ? URL.createObjectURL(image) : placeholder}
                height="200px"
                width="200px"
                style={{ borderRadius: "1000px" }}
              />
              <br />
              <TextField type="file" onChange={handleImageChange} />
              <Divider style={{ margin: "15px" }} />
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Nome do Anunciante"
                    type="text"
                    value={nome}
                    autoFocus
                    onChange={handleNomeChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Responsável"
                    type="text"
                    color="secondary"
                    value={responsavel}
                    onChange={handleResponsavelChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Email do Responsável"
                    type="email"
                    value={emailResponsavel}
                    onChange={handleEmailResponsavelChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Telefone do Responsável"
                    type="number"
                    value={telefoneResponsavel}
                    color="secondary"
                    onChange={handleTelefoneResponsavelChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                  >
                    {!loading ? "Enviar" : <CircularProgress color="primary" />}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
